import type { ReactNode } from 'react';

export const LABEL_CLASS =
  'text-[12px] leading-4 font-normal text-[rgba(0,0,0,0.81)]';
export const VALUE_STRONG_CLASS = 'intl-text-body-strong text-black';
export const VALUE_DEFAULT_CLASS =
  'text-[16px] leading-5 font-normal text-black';
export const CAPTION_CLASS =
  'mt-0.5 text-[12px] leading-4 text-[rgba(0,0,0,0.6)]';

export function Field({
  label,
  value,
  strong = true,
  caption,
}: {
  label: string;
  value: ReactNode;
  strong?: boolean;
  caption?: ReactNode;
}) {
  return (
    <div>
      <p className={LABEL_CLASS}>{label}</p>
      <p
        className={`mt-1 ${strong ? VALUE_STRONG_CLASS : VALUE_DEFAULT_CLASS}`}
      >
        {value}
      </p>
      {caption ? <p className={CAPTION_CLASS}>{caption}</p> : null}
    </div>
  );
}
